import type { Rect } from '../../../engine/hex/types';
import { IconRegistry } from '../../../ui/overlay/assets/IconRegistry';
import type { ModalTheme } from '../ModalTheme';
import type { HitTarget, MeasureResult, UiItem } from './Types';

export class JsonItem implements UiItem {
    private rect: Rect = { x: 0, y: 0, w: 0, h: 0 };
    private lines: string[];

    constructor(obj: unknown) {
        this.lines = JSON.stringify(obj, null, 2).split('\n');
    }

    measure(ctx: CanvasRenderingContext2D, maxW: number, theme: ModalTheme): MeasureResult {
        ctx.font = theme.fonts.code;
        const widths = this.lines.map((line) => ctx.measureText(line).width);
        const w = Math.min(maxW, Math.max(0, ...widths));
        return { w, h: this.lines.length * theme.lineHeights.code };
    }

    layout(x: number, y: number, w: number, theme: ModalTheme): void {
        const h = this.lines.length * theme.lineHeights.code;
        this.rect = { x, y, w, h };
    }

    draw(ctx: CanvasRenderingContext2D, theme: ModalTheme, _icons?: IconRegistry): void {
        ctx.font = theme.fonts.code;
        ctx.fillStyle = theme.colors.codeText;
        ctx.textBaseline = 'top';
        this.lines.forEach((line, index) => {
            ctx.fillText(line, this.rect.x, this.rect.y + index * theme.lineHeights.code);
        });
    }

    collectHitTargets(_out: HitTarget[], _scrollY: number): void {}
}
